import PropTypes from 'prop-types';
import React from 'react';

import alphabetise from 'site-react/core/helpers/alphabetise';
import locationsLinks from '../data/locations';
import {
  List,
  ListItem,
  LocationsContainer,
  LocationsLeftColumn,
  LocationsRightColumn,
  PopularAreasList,
  TextContainer,
  TextLink,
  Title,
} from './DesktopNavPanelStyles';

const { cities, londonAreas, popularLondonAreas } = locationsLinks;

cities.links.sort((a, b) => alphabetise(a.label, b.label));
londonAreas.links.sort((a, b) => alphabetise(a.label, b.label));
popularLondonAreas.links.sort((a, b) => alphabetise(a.label, b.label));

const DesktopNavPanelLocations = ({ clickHandler }) => (
  <div className={LocationsContainer}>
    <div className={LocationsLeftColumn}>
      <div className={Title}>{cities.title}</div>
      <ul className={List}>
        {cities.links.map((link, index) => {
          const { label, name, url } = link;
          return (
            <li className={ListItem} key={`${name}-${index + 1}`}>
              <div className={TextContainer}>
                <a
                  className={TextLink}
                  href={url}
                  onClick={(event) =>
                    clickHandler(event, {
                      analytics: cities.analytics,
                      ...link,
                    })
                  }
                >
                  {label}
                </a>
              </div>
            </li>
          );
        })}
      </ul>
      <div className={Title}>{londonAreas.title}</div>
      <ul className={List}>
        {londonAreas.links.map((link, index) => {
          const { label, name, url } = link;
          return (
            <li className={ListItem} key={`${name}-${index + 1}`}>
              <div className={TextContainer}>
                <a
                  className={TextLink}
                  href={url}
                  onClick={(event) =>
                    clickHandler(event, {
                      analytics: londonAreas.analytics,
                      ...link,
                    })
                  }
                >
                  {label}
                </a>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
    <div className={LocationsRightColumn}>
      <div className={Title}>{popularLondonAreas.title}</div>
      <ul className={PopularAreasList}>
        {popularLondonAreas.links.map((link, index) => {
          const { label, name, url } = link;
          return (
            <li className={ListItem} key={`${name}-${index + 1}`}>
              <div className={TextContainer}>
                <a
                  className={TextLink}
                  href={url}
                  onClick={(event) =>
                    clickHandler(event, {
                      analytics: popularLondonAreas.analytics,
                      ...link,
                    })
                  }
                >
                  {label}
                </a>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  </div>
);

DesktopNavPanelLocations.defaultProps = {
  clickHandler: null,
};

DesktopNavPanelLocations.propTypes = {
  clickHandler: PropTypes.func,
};

export { DesktopNavPanelLocations };
export default DesktopNavPanelLocations;
